export const simulationOfferAmortizationSystemTexts = {
  PRICE: {
    tag: "Parcelas fixas"
  },
  SAC: {
    tag: "Parcelas decrescentes"
  }
}
